import STATISTICS from '@/api/module/statistics.js';
const TRADSTATISTICS = {
  namespaced: true,
  state: {
    statisticsList: [], // 交易数据统计
    totalAmount: [], //交易订单金额
  },
  mutations: {
    // 设置已开通渠道主页
    statisticsList(state, data) {
      state.statisticsList = data;
      state.totalAmount = data.result;
    },
  },
  actions: {
    // 交易数据统计
    async getStatistics({
      commit
    }, params) {
      try {
        const result = await STATISTICS.getStatistics(params);
        commit('statisticsList', result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
  getters: {
    payPrices: state => {
      state.totalAmount.map(item=>{
        return item.payPrices
      })
    }
  },
};

export default TRADSTATISTICS;